/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import UserModel from 'uplisting-frontend/models/user';

interface IArgs {
  logoClass: string;
  permission?: string;
  title?: string;
  description?: string;
  brandType?: 'icon';
  route: string;
  external?: boolean;
}

interface ConnectHomeCardSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiConnectHomeCardComponent extends Component<ConnectHomeCardSignature> {
  @service session!: Services['session'];

  @cached
  get brandType(): 'channel-brand' | 'icon-brand' {
    if (this.args.brandType === 'icon') {
      return 'icon-brand';
    }

    return 'channel-brand';
  }

  @cached
  get logoClass(): string {
    return `${this.brandType} ${this.args.logoClass}`;
  }

  @cached
  get isPermitted(): boolean {
    const { permission } = this.args;

    if (!permission) {
      return true;
    }

    const user = this.session.currentUser as UserModel;

    return user.hasAccessTo(permission);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Connect::HomeCard': typeof UiConnectHomeCardComponent;
  }
}
